import noImage from "@/assets/images/no-image.webp";

const getImageSrc = ({
  imageCdnUrl,
  imageUrl,
}: {
  imageCdnUrl?: string | null;
  imageUrl?: string | null;
}) => {
  if (imageCdnUrl != null && imageCdnUrl.length > 0) return imageCdnUrl;
  if (imageUrl != undefined) return imageUrl;
  return noImage;
};

export { getImageSrc };
